import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "apps",
  "use": "apps-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"apps\"><path d=\"M5 3H3v2h2V3zm2 0h2v2H7V3zm4 0h2v2h-2V3zm0 4h2v2h-2V7zM9 7H7v2h2V7zM3 7h2v2H3V7zm10 4h-2v2h2v-2zm-6 0h2v2H7v-2zm-2 0H3v2h2v-2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol